import { IWatrRequest } from '@nkr/models/index';
import { isSelfEmployed } from './employment-type.utils';

export const requiresTaxDocument = (
    data: Pick<IWatrRequest, 'employmentType' | 'taxDocumentFile'>
): boolean => isSelfEmployed(data.employmentType);

export const getVerifyTaxStepLabel = (
    _data?: Pick<IWatrRequest, 'employmentType' | 'taxDocumentFile'>
): string => 'Verify SSN';

export const getVerifyTaxLoadingMessage = (
    _data?: Pick<IWatrRequest, 'employmentType' | 'taxDocumentFile'>
): string => 'Verifying SSN...';

export const getVerifyTaxSuccessMessage = (
    data: Pick<IWatrRequest, 'employmentType' | 'taxDocumentFile' | 'firstName' | 'lastName'>
): string => {
    const name = `${data.firstName} ${data.lastName}`.trim();
    return `${name} SSN has been verified.`;
};

export const getVerifyTaxErrorMessage = (
    _data?: Pick<IWatrRequest, 'employmentType' | 'taxDocumentFile'>
): string => 'Unable to verify SSN.';
